import { SmartForm, TextInputTypes } from "@avenueops/web-components";
import { AutoEscalateTimePeriod } from "@prisma/client";
import React from "react";
import { useFormContext } from "react-hook-form";

export function EscalationPolicySection(): JSX.Element {
  const { unregister, watch, setValue } = useFormContext();

  const repeat = watch("repeatEscalationPolicy");
  return (
    <div>
      <div className="flex flex-col gap-5">
        <SmartForm.Checkbox
          label="Repeat this escalation policy until the signal is resolved"
          large
          name="repeatEscalationPolicy"
          onChangeCallback={() => {
            if (!repeat) {
              setValue("maximumEscalationPolicyAttempts", null, { shouldDirty: true });
              setValue("repeatEscalationPolicyAfterTimePeriodQuantity", null, { shouldDirty: true });
              setValue("repeatEscalationPolicyAfterTimePeriod", null, { shouldDirty: true });
            }
          }}
        />
        <div className={`flex flex-row items-end gap-4 text-sm ${!repeat ? "hidden" : ""}`}>
          <span className="w-fit truncate whitespace-nowrap self-center"> {`Repeat`}</span>
          <div className="w-24">
            <SmartForm.TextInput type={TextInputTypes.NUMBER} min={1} disabled={!repeat} name="maximumEscalationPolicyAttempts" placeholder="#" />
          </div>
          <span className="whitespace-nowrap w-fit truncate self-center">times every</span>
          <div className="flex flex-row items-end gap-x-2 shrink">
            <div className="w-24">
              <SmartForm.TextInput
                type={TextInputTypes.NUMBER}
                min={1}
                disabled={!repeat}
                name="repeatEscalationPolicyAfterTimePeriodQuantity"
                placeholder="#"
              />
            </div>
            <div className="w-36">
              <SmartForm.DropdownSelect
                disabled={!repeat}
                name="repeatEscalationPolicyAfterTimePeriod"
                options={[
                  ...Object.keys(AutoEscalateTimePeriod).map((timePeriodKey) => ({
                    label: timePeriodKey.toLowerCase(),
                    value: AutoEscalateTimePeriod[timePeriodKey as AutoEscalateTimePeriod],
                  })),
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
